import type { ProjectId } from "features/shared/model/types";

const ifcApiBase = process.env.REACT_APP_IFC_API_URL;
const processingApiBase = process.env.REACT_APP_PROCESSING_API_URL;

const upload = () => `${ifcApiBase}/api/ifc/upload`;
const ifcJobsByProject = (projectId: ProjectId) => `${ifcApiBase}/api/jobs/by-project?project_id=${projectId}`;
const processingJobsByProject = (projectId: ProjectId) => `${processingApiBase}/api/jobs?project_id=${projectId}`;

const executionUrls = {
  ifcJobsByProject,
  processingJobsByProject,
  upload,
};

export default executionUrls;
